module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Writing is hard, and goodness knows this is not my first attempt at writing a book. But this is the first time that I’ve written a book good enough to share, and so many people have helped bring my book to life.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("First, I would like to express my most heartfelt gratitude to my grandparents. Before Austin Macauley saw promise in my story, Granny and Grandad had a few beautiful copies printed themselves. I could not be more grateful to have the physical book in my hands. Even if it took many proofs to get it right, it is incredible.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("A huge thanks also goes to my sister who has been editing my story since chapter one. Without her, "), _c('em', [_vm._v("Soul Fire")]), _vm._v(" may not have made sense – tenses are hard! She has stuck by me, reading the book every few chapters and giving me feedback, making sure I'm keeping the story straight and catching anything essential I happened to miss.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("My gratitude to Gen, who has drawn a fantastic map and other amazing concept art for "), _c('em', [_vm._v("Soul Fire, helping")]), _vm._v(" me see my story come to colored life. She designed the covers for both the book Granny and Grandad printed and helped create inspiration for the cover of this book.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Thank you, Kathryn, for being the first one to “fangirl” about the book, really helping me believe in the story’s strength. Without you, I may never have shared it further. And who knows, I may not have gotten working on Book Two quite so quickly if you weren't asking me what happens next!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Thank you, Mat, who supported me through my journey to find a publisher and helped me celebrate when Austin Macauley said yes.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Thank you, to the entire team at Austin Macauley,  who saw promise in my book and offered to publish it. Your hard work in the editing, art design and all other areas of creating a printed and saleable book are greatly appreciated.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Lastly, thank you to my parents. Without them I would not have had many of the experiences that inspired my work. As my Dad said when helping me with writing years ago, “It is better to write about what you know.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-025fec64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0